import React from "react";
import styles from "./product-card.module.scss";
import { sanitize } from "../../../util/util";
import wellnessImage from "../../data/generic.jpeg";
import fashionImage from "../../data/fashion.jpg";
import classNames from "classnames";

import {
  ButtonActionType,
  ProductActionButton,
} from "../product-action-button/product-action-button";

export interface ProductData {
  title: string;
  compare_at_price: string;
  on_sale: boolean;
  sale_percentage: number;
  out_of_stock: boolean;
  discounted_price: number;
  product_name: string;
  product_url: string;
  description: string;
  brand: string;
  retail_price: string;
  price: string;
  image: string;
  handle: string;
  rating?: number;
  review_count?: number;
  variants: any[];
}

interface Props {
  data: ProductData;
}

const type = process.env.REACT_APP_ECOMMERCE;

export const ProductCard: React.FC<Props> = ({ data }) => {
  const [showMore, setShowMore] = React.useState(false);
  const discountedPrice = window.isCustomStore ? data.discounted_price : data.price;
  const image = type === "oziva" ? wellnessImage : fashionImage || data.image;
  const description = sanitize(data.description).slice(0, 180);

  let title = window.isCustomStore ? data.product_name : data.title;
  title = sanitize(title);

  return (
    <div className={styles.productCard}>
      <div className={styles.topSection}>
        <div className={styles.imageContainer}>
          <img
            src={image.replace(/[["']/g, "")}
            alt={title}
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/300?text=Image%20not%20available";
            }}
          />
        </div>
        <div className={styles.title}>{title}</div>
        {data.description ? (
          <div className={styles.description}>
            {showMore ? sanitize(data.description) : description + "..."}{" "}
            <button onClick={() => setShowMore(!showMore)}>
              {showMore ? "Show less" : "Show more"}
            </button>
          </div>
        ) : (
          <div style={{ height: "94px" }}></div>
        )}
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.priceContainer}>
          <div className={styles.price}>Rs. {discountedPrice}</div>
        </div>
      </div>
    </div>
  );
};
